// extracted by mini-css-extract-plugin
export default {"header":"SidePanel_header__wvv9M","close":"SidePanel_close__f6FHU","drawer":"SidePanel_drawer__2PgxW"};